import React, { useContext, useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getLastSegmentFromPath } from '../utils';
import { AuthContext, BaseRoute, getLoginUrl, SessionTimeout } from '../index';
import { ConfirmBeforeExit } from '../../Components/ConfirmBeforeExit';

const PrivateRoute = ({ component: Component, showConfirmOnClose, ...otherProps }) => {
    const { checkIsAuthenticated } = useContext(AuthContext);
    const location = useLocation();

    const Login = () => {
        useEffect(() => {
            (async () => {
                try {
                    const loginUrl = await getLoginUrl();
                    const routeName = getLastSegmentFromPath(location.pathname);
                    localStorage.setItem('redirectTo', routeName);
                    // we parse it here to ensure it is well-formed
                    // if the middle tier were not running this could be a 404 error message from the router
                    // in development we allow this to be relative (as the mock proxy simulates this)
                    const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
                    if (!development) {
                        new URL(loginUrl); // parsedLoginUrl
                        // The next line redirects to MyAccount and THIS APP DIES.
                        // Once MyAccount has finished authenticating the user, this app gets rebooted from the authenticate page.
                        // To redirect the user to the original page they were trying to
                        // get to, we have just saved it to local storage before calling the next line.
                    }
                    console.log('redirecting to login server at ', loginUrl);
                    // The next line redirects to MyAccount and THIS APP DIES.
                    // Once MyAccount has finished authenticating the user, this app gets rebooted from the authenticate page.
                    // To redirect the user to the original page they were trying to
                    // get to, we have just saved it to local storage before calling the next line.
                    window.location.href = loginUrl;
                } catch (e) {
                    console.error('An error occurred getting login URL, middle tier may not be working!');
                }
            })();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return <></>;
    };

    const sessionTimeoutEnabled = otherProps.sessionTimeoutEnabled ?? true;

    return (
        <BaseRoute
            { ...otherProps }
            render={ props => (
                checkIsAuthenticated() ?
                    <>
                        <ConfirmBeforeExit showConfirmOnClose={ showConfirmOnClose } />
                        {sessionTimeoutEnabled &&
                            <SessionTimeout
                                timeoutIntervalInSeconds={ otherProps.timeoutIntervalInSeconds }
                                numberOfIntervals={ otherProps.numberOfIntervals }
                            />}
                        <Component { ...props } />
                    </> :
                    <Login />
            ) }
        />
    );
};

PrivateRoute.displayName = 'PrivateRoute';

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
    timeoutIntervalInSeconds: PropTypes.number,
    numberOfIntervals: PropTypes.number,
    showConfirmOnClose: PropTypes.bool
};

PrivateRoute.defaultProps = {
    timeoutIntervalInSeconds: 900,
    numberOfIntervals: 3,
    showConfirmOnClose: true

};

export default memo(PrivateRoute);
